import script from "./FormDico.vue?vue&type=script&setup=true&lang=js"
export * from "./FormDico.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__